import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cep-lookup"
export default class extends Controller {
  static targets = ["input", "state", "city", "neighborhood", "address", "address_number"]

  connect() {
    this.maskCEP()
  }

  maskCEP() {
    const input = this.inputTarget
    input.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '')
      if (value.length > 8) value = value.slice(0, 8)

      if (value.length > 5) {
        value = value.slice(0, 5) + '-' + value.slice(5)
      }

      e.target.value = value

      if (value.replace(/\D/g, '').length === 8) {
        this.fetchAddress(value.replace(/\D/g, ''))
      }
    })
  }

  async fetchAddress(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = await response.json()
      
      if (!data.erro) {
        this.stateTarget.value = data.uf
        this.neighborhoodTarget.value = data.bairro
        this.addressTarget.value = data.logradouro
        
        // Event captured by state-city controller to fetch cities and select the city for
        // designated CEP(zipcode)
        this.element.setAttribute('data-cep-city', data.localidade)
        const event = new Event('change', { bubbles: true })
        this.stateTarget.dispatchEvent(event)

        
        if (this.hasAddressNumberTarget) {
          this.addressNumberTarget.focus()
        }
      }
    } catch (error) {
      console.error("Erro ao buscar CEP:", error)
    }
  }
}
